import hlfNoImage from '@client/shared/images/hlf-no-image.jpeg';

export function cleanHttpsLink(httpLink) {
  if (httpLink && httpLink.replace) {
    return httpLink.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0];
  } else {
    return '';
  }
}

export function prefixHttpsLink(httpLink) {
  if (httpLink && httpLink.startsWith) {
    if (!httpLink.startsWith('https://') && !httpLink.startsWith('http://')) {
      return `https://${httpLink}`;
    } else {
      return httpLink;
    }
  } else {
    return '';
  }
}

export function smartLinkPrefixer(prefix, linkSegment) {
  if (linkSegment && linkSegment.startsWith) {
    if (
      !linkSegment.startsWith('https://') &&
      !linkSegment.startsWith('http://') &&
      !linkSegment.startsWith('www.')
    ) {
      return `${prefix}${linkSegment}`;
    } else {
      return linkSegment;
    }
  } else {
    return '';
  }
}

export function addPrefixBeforeFileExtension(fileUrl = '', prefix) {
  const dotIndex = fileUrl.lastIndexOf('.');
  if (dotIndex === -1) return fileUrl + prefix;
  else
    return (
      fileUrl.substring(0, dotIndex) + prefix + fileUrl.substring(dotIndex)
    );
}

export function valueOrEmptyStr(value) {
  return value || '';
}

export function valueOrZero(value) {
  return value || 0;
}

export function remapObjValueToString(obj) {
  return Object.entries(obj).reduce((acum, [key, value]) => {
    acum[key] = value.toString();
    return acum;
  }, {});
}

// Truncates a string and replace the end with '...'.
// We do this since not all browsers support multiline ellipsis.
export const fakeEllipsis = (text, maxCharNumber) => {
  if (typeof text === 'string' && text.length > maxCharNumber) {
    return `${text.substring(0, maxCharNumber - 2).trim()}…`;
  } else {
    return text;
  }
};

export const formDataAppender = (formData, valueName, value, fileName) => {
  if (value) {
    if (fileName) {
      formData.append(valueName, value, fileName);
    } else {
      formData.append(valueName, value);
    }
  }
};

export const getImageOrDefault = (imgUrl) => {
  return imgUrl ? imgUrl : hlfNoImage;
};

export function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function guid() {
  var guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(
    c
  ) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;

    return v.toString(16);
  });

  return guid;
}

// To prevent page jump
export function valueOrSpace(value) {
  return value || ' ';
}

export function setCookie(cname, cvalue, exdays) {
  let d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${JSON.stringify(cvalue)}${
    window.location.host !== 'localhost:3000' ? ';secure' : ''
  };${expires};path=/`;
}

export function deleteCookie(cname) {
  document.cookie = `${cname}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
}

export function isGUID(str) {
  const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return str && str.match && str.match(guidPattern);
}
